import {Component, OnInit} from '@angular/core';
import {WhoisOnlineService} from '@app/services/IdleAndWhoseOnline/whois-online.service';
import {OnDestroyMixin, untilComponentDestroyed} from '@w11k/ngx-componentdestroyed';
import {environment} from '@environments/environment';
import {confirm} from 'devextreme/ui/dialog';
import {TranslateService} from '@ngx-translate/core';
import {ToastrService} from 'ngx-toastr';

@Component({
    selector: 'app-update-info',
    templateUrl: './update-info.component.html',
    styleUrls: ['./update-info.component.scss'],
    standalone: false
})
export class UpdateInfoComponent extends OnDestroyMixin implements OnInit {

  private appUrl = environment.appUrl;

  constructor(
    public translate: TranslateService,
    public whoisOnlineService: WhoisOnlineService,
    private toastr: ToastrService,
  ) {
    super();
  }

  ngOnInit(): void {

    this.whoisOnlineService.liveAppUuid$
      .pipe(
        untilComponentDestroyed(this)
      ).subscribe((version) => {
      if (version.hasNewVersion) {

        this.toastr.success(
          this.translate.instant('Nouvelle version de l\'application disponible.'),
          this.translate.instant('Nouvelle version'),
          {
            timeOut: 2000,
            progressBar: true,
          });
      }
    });

  }

  updateApp(newVersion: string) {

    confirm(
      this.translate.instant('Mettre à jour l\'application ?<br>Toutes les modifications <b>non enregistrées</b> seront perdues.'),
      this.translate.instant('Mise à jour')
    ).then((dialogResult) => {
      if (dialogResult) {
        localStorage.setItem('appUuid', newVersion);
        window.location.replace(`${this.appUrl}/index.html?forceRefresh=${new Date().getTime()}`);
      }
    });


  }
}
